import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import Calendar from '../Home/Calendar/Calendar';
import Noticeboard from '../Home/Calendar/Noticeboard/Noticeboard';

function DeviceAttendanceAnalytics() {
  const [activeTab, setActiveTab] = useState('calendar'); // 'calendar' | 'board'

  return (
    <Box sx={{ maxWidth: 1400, mx: 'auto', px: 3, py: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: '#e9dede', mt: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          TabIndicatorProps={{ style: { backgroundColor: '#6B1D2F' } }}
          sx={{
            minHeight: 'auto',
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 700,
              fontSize: 14,
              color: '#705A5E',
              minHeight: 'auto',
              padding: '12px 6px',
              marginRight: 3,
            },
            '& .Mui-selected': { color: '#6B1D2F !important' },
          }}
        >
          <Tab label="Kalendarz" value="calendar" />
          <Tab label="Tablica ogłoszeń" value="board" />
        </Tabs>
      </Box>

      {activeTab === 'calendar' && <Calendar />}
      {activeTab === 'board' && <Noticeboard />}
    </Box>
  );
}

export default DeviceAttendanceAnalytics;